import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer } from '@ckeditor/ckeditor5-core/src/editor';
import { addEmptyParagraphAfterPlugin } from '../utils';

export class AIFillInsertCommand extends Command {
  refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      'aiFill',
    );

    this.isEnabled = allowedIn !== null;
  }

  execute({ appId, asReadOnly, uniqueId, targetRange }) {
    const { editor } = this;

    editor.model.change((writer: Writer) => {
      const aiFillElement = writer.createElement('aiFill', {
        appId: appId.toString(),
        uniqueId,
        asReadOnly,
      });

      editor.model.insertContent(aiFillElement, targetRange);
      addEmptyParagraphAfterPlugin(editor, writer, aiFillElement);
    });
  }
}
